module.exports = __webpack_public_path__ + "static/media/venue.81ae64a3.svg";